export default "__VITE_ASSET__BYUF9Ej3__"